// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { FormFilterPriority } from "../schema";

export function serialize_FormFilterPriority_internal(value: FormFilterPriority): unknown {
  return ((value: "PRIMARY" | "SECONDARY"): unknown => {
    return value;
  })(value);
}
export function serialize_FormFilterPriority(obj: FormFilterPriority): string {
  return renderJsonWithNumbersAsBigint(serialize_FormFilterPriority_internal(obj));
}
export function deserialize_FormFilterPriority_internal(value: unknown): ParserResult<FormFilterPriority> {
  return ((value: unknown): ParserResult<"PRIMARY" | "SECONDARY"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/FormFilterPriority]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "PRIMARY":
        return { success: true, value: "PRIMARY" };
      case "SECONDARY":
        return { success: true, value: "SECONDARY" };
      default:
        return { success: false, reason: `[#/components/schemas/FormFilterPriority]: '${value}' expected to be enum, one of 'PRIMARY, SECONDARY'.` };
    }
  })(value);
}
export function deserialize_FormFilterPriority(str: string): ParserResult<FormFilterPriority> {
  return deserialize_FormFilterPriority_internal(parseJsonWithNumbersAsBigint(str));
}
